(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daggry-press"] && !Shopify.designMode) return;
  try {
    
  const addWelcomeCode = () => {
    document.querySelectorAll('.email-signup__message-text').forEach((message) => {
      if (message.querySelector('.daggry-welcome-code')) return;

      const code = document.createElement('strong');
      code.className = 'daggry-welcome-code';
      code.textContent = 'VELKOMMEN10';
      message.append(code);
    });
  };

  addWelcomeCode();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero__media img:not([alt])').forEach((image) => {
    image.setAttribute('alt', '');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
